import React, { ChangeEvent, FC } from "react";
import { ConnectedProps, connect } from "react-redux";
import { Checkbox, CheckboxOnChangeData, Label } from "@fluentui/react-components";

import { IUhfViewState } from "../../../../pages/Contracts";
import { IRapComponentProperties } from "../../../../platform/Layout";
import { FlexContainer } from "../../../../common/components/FlexContainer/FlexContainer";
import { ITestConfiguration } from "../../Contracts";
import { TestActions } from "../../redux/TestActions";
import { localizedStrings } from "../../../../common/localization/LocalizedStrings";

import * as TestSelectors from "../../redux/TestSelectors";
import { useSearchParams } from "react-router-dom";

interface IOptionsSelectorProvidedProps extends IRapComponentProperties {
    className?: string;
}

interface IOptionsSelectorOwnProps {
    testConfig?: ITestConfiguration;
}

export type IOptionsSelectorProps = ConnectedProps<typeof connector> & IOptionsSelectorProvidedProps;

const OptionsSelectorInitializer: FC<IOptionsSelectorProps> = (props) => {
    const [searchParams, setSearchParams] = useSearchParams();
    
    const onPreviewChanged = (ev: ChangeEvent<HTMLInputElement>, data: CheckboxOnChangeData) => {
        props.setTestConfig({ options: {...props.testConfig.options, preview: data.checked as boolean }});
    }

    const onDebugChanged = (ev: ChangeEvent<HTMLInputElement>, data: CheckboxOnChangeData) => {
        props.setTestConfig({ options: {...props.testConfig.options, debug: data.checked as boolean }});
    }

    const onCookieComplianceChanged = (ev: ChangeEvent<HTMLInputElement>, data: CheckboxOnChangeData) => {
        props.setTestConfig({ options: {...props.testConfig.options, cookieCompliance: data.checked as boolean }});
    }

    const onVNextChanged = (ev: ChangeEvent<HTMLInputElement>, data: CheckboxOnChangeData) => {
        props.setTestConfig({ options: {...props.testConfig.options, vNext: data.checked as boolean }});
    }

    return (
        <FlexContainer ariaLabel="Options" wrap="wrap" className={`${props.className ? props.className : ""}`}>
            <Label className="c-field-label">{localizedStrings.TestView?.TestConfigurator?.options}</Label>
            <Checkbox aria-label="Preview" label={"Preview"} onChange={onPreviewChanged} checked={props.testConfig?.options?.preview}/>
            <Checkbox aria-label="Debug" label={"Debug"} onChange={onDebugChanged} checked={props.testConfig?.options?.debug}/>
            <Checkbox aria-label="Cookie compliance" label={"Cookie Compliance"} onChange={onCookieComplianceChanged} checked={props.testConfig?.options?.cookieCompliance}/>
            {searchParams.get("vNext") && (
                <Checkbox label={"vNext"} onChange={onVNextChanged} checked={props.testConfig?.options?.vNext}/>
            )}
        </FlexContainer>
    );
}

function mapStateToProps(state: IUhfViewState, providedProps: IOptionsSelectorProvidedProps): Partial<IOptionsSelectorOwnProps> {
    return {
        ...providedProps,
        testConfig: TestSelectors.getTestConfig(state)
    };
}

const ActionsToDispatch = {
    setTestConfig: TestActions.setTestConfig
};

const connector = connect(
    mapStateToProps,
    ActionsToDispatch,
    null,
    { forwardRef: true }
);

export const OptionsSelector = connector(OptionsSelectorInitializer);